module.exports = __webpack_public_path__ + "static/img/monigote.bdc4cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/monigote.png
// module id = iO+J
// module chunks = 2